<script setup lang="ts">
import { computed } from "vue";
import MarkdownIt from "markdown-it";
import DOMPurify from "dompurify";

const props = defineProps<{ source: string | null | undefined }>();

// Single MarkdownIt instance reused across all <Markdown> renders.
const md = new MarkdownIt({
  linkify: true,
  typographer: true,
  breaks: true,
});

const html = computed<string>(() => {
  if (!props.source) return "";
  // Source is *untrusted*: comments are written by signed-in users, and even
  // the automated-reviewer ingest path (POST /api/reviews via bearer token)
  // can carry whatever markdown the agent produces. Sanitising the rendered
  // HTML through DOMPurify is what keeps stored XSS out of the SPA.
  return DOMPurify.sanitize(md.render(props.source));
});
</script>

<template>
  <div class="md" v-html="html"></div>
</template>
